import { NgModule } from '@angular/core';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MATERIAL_SANITY_CHECKS } from '@angular/material/core';


@NgModule({
    exports: [
        MatProgressBarModule,
    ],
    providers: [
        // Switch off warning "Could not find Angular Material core theme"
        {provide: MATERIAL_SANITY_CHECKS, useValue: false}
    ]
})
export class AngularMaterialModules {}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./node_modules/angular-router-loader/src?loader=system&genDir=compiled&aot=false!./src/app/utils/angular_material_modules.ts